module.exports = __webpack_public_path__ + "media/banners/embex_education-36636b88.png";